module.exports = __webpack_public_path__ + "static/media/sg.5f9b8bce.jpg";